import { Redirect, Route } from 'react-router-dom';
import { isLoggedOutRedirect, resolveReturnPath } from 'utils/return-url';

/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

const PublicRoute = ({ render, isLoggedIn, ...rest }) => (
  <Route
    {...rest}
    render={(otherProps) => {
      const { location } = otherProps;

      // A deliberate sign-out navigates here while the session teardown is still in
      // flight, so isLoggedIn is briefly still true. The `loggedOut` marker rides the
      // query string (hash history drops history state) so we can tell that apart and
      // not bounce the user back into the app they just chose to leave.
      if (isLoggedIn === false || isLoggedOutRedirect(location.search)) {
        return render(otherProps);
      }

      // Already authenticated: honor `return` so a deep link still reaches its
      // destination when the session is restored rather than freshly logged in.
      return <Redirect to={resolveReturnPath(location.search)} />;
    }}
  />
);

export default PublicRoute;
